import React, { useEffect, useState } from "react";
import {
  CancelButton,
  UpdateButton,
} from "../../../../components/mui/Buttons/Buttons";
import { Form, FormikProvider, useFormik } from "formik";
import { Box, Stack, TextField } from "@mui/material";
import GlobalDialog from "../../../../components/mui/Dialogue/GlobalDialog";
import GlobalSelectField from "../../../../components/mui/GlobalSelectField";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import {
  getSmeSchedules,
  getSubjectEnrollmentId,
  updateSmeSchedules,
} from "../../../../redux/features/smeSlice";

const UpdateSmeSchedule = ({ rowData, leadId, dispatchdata }) => {
  const [open, setOpen] = useState(false);

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { loading, subjectEnrollId } = useSelector((state) => state.sme);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      sme_schedules_topic_id: rowData.sme_schedules_topic_id,
      session_no: rowData.session_no,
      chapter: rowData.chapter,
      topic: rowData.topic,
      objectives: rowData.objectives,
      status: rowData.status,
      subject_enrollment_id: rowData.subject_enrollment_id,
    },
    onSubmit: (values) => {
      dispatch(updateSmeSchedules({ data: [values] })).then((res) => {
        console.log(res);
        if (res.payload.status === "success") {
          enqueueSnackbar(res.payload.message, {
            variant: "success",
          });
          dispatch(getSmeSchedules(dispatchdata));
          setOpen(false);
        } else {
          enqueueSnackbar(res.payload.message, {
            variant: "error",
          });
          // setOpen(false);
        }
      });
    },
  });

  const statusDemo = [
    { id: 0, name: "Active" },
    { id: 1, name: "Inactive" },
  ];

  useEffect(() => {
    if (open) {
      dispatch(getSubjectEnrollmentId(leadId));
    }
  }, [leadId, open]);

  return (
    <GlobalDialog
      title={"Update Schedule"}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={"md"}
      closeButton={true}
      popupButton={
        <UpdateButton size="medium" action={() => setOpen(true)}>
          Update
        </UpdateButton>
      }
      content={
        <>
          <FormikProvider value={formik}>
            <Form onSubmit={formik.handleSubmit}>
              <Box>
                <Stack direction={"column"} spacing={2}>
                  <GlobalSelectField
                    options={{
                      formik,
                      name: "subject_enrollment_id",
                      label: "Subject Enrollment",
                      data: subjectEnrollId?.data?.map((item) => ({
                        ...item,
                        course_name: `${item.course_name} - ${item.subject_name}`,
                      })),
                      keys: {
                        id: "subject_enrollment_id",
                        value: "course_name",
                      },
                    }}
                  />
                  <TextField
                    name="session_no"
                    type="number"
                    value={formik.values.session_no}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Session No"
                  />
                  <TextField
                    name="chapter"
                    value={formik.values.chapter}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Chapter"
                  />
                  <TextField
                    name="topic"
                    value={formik.values.topic}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Topic"
                  />
                  <TextField
                    name="objectives"
                    value={formik.values.objectives}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Objectives"
                  />
                  {/* <TextField
                    name="status"
                    type="number"
                    value={formik.values.status}
                    onChange={formik.handleChange}
                    fullWidth
                    label="Status"
                  /> */}
                  {/* <GlobalSelectField
                    options={{
                      formik,
                      name: "status",
                      label: "Status",
                      data: statusDemo,
                      keys: {
                        id: "id",
                        value: "name",
                      },
                    }}
                  /> */}
                </Stack>
                <Box
                  sx={{ display: "flex", justifyContent: "flex-end", pt: 2 }}
                >
                  <Stack direction={"row"} spacing={1}>
                    <CancelButton size="small" action={() => setOpen(false)}>
                      Cancel
                    </CancelButton>
                    <UpdateButton disabled={loading} size="small" type="submit">
                      {loading ? "Please wait..." : "Update"}
                    </UpdateButton>
                  </Stack>
                </Box>
              </Box>
            </Form>
          </FormikProvider>
        </>
      }
    />
  );
};

export default UpdateSmeSchedule;
